<template>
    <div id="breadcrumb">
        <div class="ui divider"></div>
        <div class="ui breadcrumb">
            <i class="icon refresh pointer" @click="refresh" style="cursor: pointer;"></i>目前位置：
            <router-link :to="{name: 'index'}" class="section">首頁</router-link>

            <span v-for="(current_action, index) in $store.state.breadcrumbs">
                <i class="right chevron icon divider" v-if="current_action"></i>
                <span v-if="index == $store.state.breadcrumbs.length - 1">
                    <div class="section" v-html="current_action.name">
                    </div>
                </span>
                <span v-else>
                    <router-link
                        :to="{name: current_action.route_name}"
                        class="active section"
                        v-html="current_action.name">
                    </router-link>
                </span>
            </span>
        </div>
        <div class="ui divider"></div>
    </div>
</template>

<script>
export default {
    computed: {
    },
    methods: {
        refresh() {
            location.reload()
        },
    },
}
</script>
